"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllQuestionStartNumbersHelper = void 0;
var _find2 = _interopRequireDefault(require("lodash/find"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getAllQuestionStartNumbersHelper = function getAllQuestionStartNumbersHelper(list, allElements) {
  var result = {};
  var count = 1;
  function loopChildren(id) {
    var element = list[id];
    var elementType = (0, _find2["default"])(allElements, {
      code: element.type
    });
    if (elementType && elementType.getTotalQuestionNumbers && !element.settings.questionNumbersHide) {
      if (element.settings.questionNumbersReset) {
        count = +element.settings.questionNumbersResetNumber;
      }
      result[id] = count;
      count += elementType.getTotalQuestionNumbers(element.settings);
    }
    if (list[id].children) {
      list[id].children.forEach(function (childId) {
        return loopChildren(childId);
      });
    }
  }
  if (!list[0]) {
    return {};
  }
  list[0].children.map(function (childId) {
    return loopChildren(childId);
  });
  return result;
};
exports.getAllQuestionStartNumbersHelper = getAllQuestionStartNumbersHelper;